import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import theme from "~/styles/theme";
import { omitNonReactProps } from "~/services/utils";
var X = function(_param) /*#__PURE__*/ {
    var _fill = _param.fill, fill = _fill === void 0 ? theme.colors.icon : _fill, _size = _param.size, size = _size === void 0 ? "24" : _size, otherProps = _object_without_properties(_param, [
        "fill",
        "size"
    ]);
    return _jsx("svg", _object_spread_props(_object_spread({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, omitNonReactProps(otherProps)), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M 13.712 10.622 L 20.414 3 L 18.826 3 L 13.007 9.618 L 8.36 3 L 3 3 L 10.028 13.007 L 3 21 L 4.588 21 L 10.733 14.012 L 15.64 21 L 21 21 L 13.712 10.622 Z M 11.537 13.096 L 10.826 12.099 L 5.16 4.17 L 7.599 4.17 L 12.171 10.569 L 12.884 11.566 L 18.827 19.883 L 16.388 19.883 L 11.537 13.096 Z"
        })
    }));
};
export default X;
